import $ from 'jquery';
import intlTelInput from 'intl-tel-input';
import { map } from 'leaflet';

//----------------------------------------------------
// Development Page Functions
//----------------------------------------------------

function propertyCardImageSlider(){
    var target = $('.property-card .property-images .property-slider');
    
    if(target.length) {
        target.each(function () {
            $(this).slick({
                infinite: true,
                slidesToShow: 1,
                dots: false,
                autoplay: false,
                autoplaySpeed: 3000,
                prevArrow: '<i class="fa fa-chevron-left prev-arrow"></i>',
                nextArrow: '<i class="fa fa-chevron-right next-arrow"></i>'
            })
        })
    }
}

function propertyCardPriceRangeScroll(){
    var target = $('.btn-pricerange-cta');
    
    if(target.length) {
        
        target.each(function () {

            // check if cards exist for pricerange and hide button if not
            var pricerange = $(this).data('pricerange');
            var cardExists = $('.property-card[data-pricerange="' + pricerange + '"]').length > 0;
            
            if (!cardExists) {
                $(this).addClass('hidden');
            }

            // scroll to card
            $(this).on('click', function(e) {
                e.preventDefault();
                
                var pricerange = $(this).data('pricerange');
                var card_target = $( '.property-card[data-pricerange="' + pricerange + '"]');
                var scroll_top = card_target.length ? card_target.offset().top - $('header nav').height() - 20 : $('.development-properties-section').offset().top - $('header nav').height() - 20;

                $('html, body').animate({
                    scrollTop: scroll_top
                }, 2000);
            })
        })
    }
}

function propertyCardFilterByPropertyTypes(){

    var target = $('.development-properties-section .property-types-list li button');
    
    if(target.length) {
        
        target.each(function () {

            var propertyType = $(this).data('propertytype');
            var cardExists = $('.property-card[data-propertytype="' + propertyType + '"]').length > 0;
            
            // hide property types that don't have cards
            if (cardExists || propertyType == 'all') {
                $(this).closest('li').removeClass('hidden');
            }

            // filter cards by property type
            $(this).on('click', function(e) {
                e.preventDefault();

                target.removeClass('active');
                $(this).addClass('active');


                var propertyType = $(this).data('propertytype');
                $('.development-properties-section .property-card').closest('.col-property').addClass('hidden');
                $('.development-properties-section .property-card[data-propertytype="' + propertyType + '"]').closest('.col-property').removeClass('hidden');

                if(propertyType == 'all') {
                    $('.development-properties-section .property-card').closest('.col-property').removeClass('hidden');
                }
            })
        })
    }
}

function customModal(){

    var target = $('.custom-modal-container ');
    
    if(target.length) {

        target.each(function () {

            var $modalContainer = $(this);

            // Close modal
            $modalContainer.find('.close-btn').on('click', function() {
                const $modal = $(this).closest('.modal');
                $modal.removeClass('active');
                $('body').css('overflow', ''); // Restore scrolling
            });
    
            // Close modal on backdrop click
            $modalContainer.find('.modal').on('click', function(e) {
                if ($(e.target).hasClass('modal')) {
                $(this).removeClass('active');
                $('body').css('overflow', ''); // Restore scrolling
                }
            });
    
            // Trap focus within modal
            $modalContainer.find('.modal').on('keydown', function(e) {
                if (e.key === 'Tab' && $(this).hasClass('active')) {
                const $focusable = $(this).find('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])').filter(':visible');
                const $first = $focusable.first();
                const $last = $focusable.last();
    
                if (e.shiftKey && $(document.activeElement).is($first)) {
                    e.preventDefault();
                    $last.focus();
                } else if (!e.shiftKey && $(document.activeElement).is($last)) {
                    e.preventDefault();
                    $first.focus();
                }
                }
            });

        });

        // Open modal
        $('.open-modal').on('click', function(e) {
            e.preventDefault();
            const modalId = $(this).attr('data-modal');
            const propertyid = $(this).attr('data-propertyid');
            const propertyname = $(this).attr('data-propertyname');
            const $modal = $('#' + modalId);
            $modal.addClass('active');
            $modal.find('.modal-content').attr('tabindex', '-1').focus(); // Mimic Bootstrap focus
            $modal.find('#property_id').val(propertyid);
            $modal.find('#propertyname').text(propertyname);
            $('body').css('overflow', 'hidden'); // Prevent scrolling
        });
        
    }
}

function developmentAreasSlider(){
    var target = $('.development-areas-slider');
    
    if(target.length) {
        target.slick({
            infinite: true,
            slidesToShow: 5,
            slidesToScroll: 1,
            dots: true,
            autoplay: false,
            autoplaySpeed: 3000,
            prevArrow: '<i class="fa fa-chevron-left prev-arrow"></i>',
            nextArrow: '<i class="fa fa-chevron-right next-arrow"></i>',
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        infinite: true,
                        dots: true
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        })
    }
}

function ajaxForm(){

    var target = $('.ajax-form');
    
    if(target.length) {

        target.each(function () {

            var this_form = $(this);
            const RECAPTCHA_SITE_KEY = this_form.data('recaptchakey');

            // Initialize form submission handler
            this_form.find('.btn-submit').click(function() {

                grecaptcha.ready(function() {
                    grecaptcha.execute(RECAPTCHA_SITE_KEY, {action: 'submit'})
                        .then(function(token) {
                            submitForm(token, this_form);
                        }).catch(function(error) {
                            showError('reCAPTCHA verification failed. Please try again.');
                            console.error('reCAPTCHA error:', error);
                            this_form.find('.btn-submit').prop('disabled', false).text('Submit');
                        });
                });
            });


        });
    

      // Form submission function
      function submitForm(recaptchaToken, the_form) {
          let formData = {
              name: the_form.find('.input-name').val(),
              email: the_form.find('.input-email').val(),
              telephone: the_form.find('.input-phone').val(),
              reason: the_form.find('.input-reason').val(),
              property_id: the_form.find('.input-property-id').val(),
              current_page: the_form.find('.current_page').val(),
              'g-recaptcha-response': recaptchaToken
          };

            let  btn_txt = the_form.find('.btn-submit').text();

            the_form.find('.btn-submit').prop('disabled', true).text('Submitting...');

            // loop on required fields
            var requiredFields = [];
            the_form.find('.required').each(function() {
                if (!$(this).val()) {
                    requiredFields.push($(this).attr('name'));
                }
            });

            // clear errors
            the_form.find('.error').removeClass('error');

          // Basic validation
          if (requiredFields.length > 0) {
              showError('Please fill in all required fields.');
              the_form.find('.btn-submit').prop('disabled', false).text(btn_txt);

              // highlight required fields
              requiredFields.forEach(function(field) {
                  the_form.find('.form-control[name="' + field + '"]').addClass('error');
              });

              return;
          }

          let csrfToken = $('meta[name="csrf-token"]').attr('content');
          if (!csrfToken) {
              showError('CSRF token is missing. Please refresh the page and try again.');
              the_form.find('.btn-submit').prop('disabled', false).text(btn_txt);
              return;
          }

        // Push event to GTM dataLayer
        if (window.dataLayer) {
            let eventLabel = the_form.data('form');
            console.log({eventLabel});
            window.dataLayer.push({
                event: 'form_submission',
                event_category: 'Enquiry',
                event_label: eventLabel,
                value: 1
            });
        } else {
            console.warn('GTM dataLayer is not defined');
        }

          $.ajax({
              url: the_form.attr('action'),
              type: 'POST',
              data: formData,
              dataType: 'json',
              headers: {
                  'X-CSRF-TOKEN': csrfToken
              },
              beforeSend: function() {
                  the_form.find('.btn-submit').prop('disabled', true).text('Submitting...');
              },
              success: function(response) {

                  if (response.status === 'success') {

                      $('.modal-notif').html('<div class="alert alert-success">' + response.message + '</div>');
                      the_form[0].reset();

                      // Redirect to thank you page
                      if(the_form.attr('data-redirect')) {
                          window.location.href = the_form.attr('data-redirect');
                      }

                  } else {
                      showError(response.message || 'An error occurred. Please try again.');
                  }

              },
              error: function(xhr) {
                  let errorMessage = 'An error occurred. Please try again.';
                  if (xhr.responseJSON && xhr.responseJSON.message) {
                      errorMessage = xhr.responseJSON.message;
                  }
                  showError(errorMessage);
              },
              complete: function() {
                  the_form.find('.btn-submit').prop('disabled', false).text(btn_txt);
              }
          });
      }

      // Helper function to display error messages
      function showError(message) {
          $('.modal-notif').empty();
          let errorDiv = $('<div class="alert alert-danger mt-3">' + message + '</div>');
          $('.modal-notif').prepend(errorDiv);
          setTimeout(function() {
              errorDiv.fadeOut('slow', function() { $(this).remove(); });
          }, 5000);
      }
    }
}

function formIntTelInput() {

    if ($('.intTel_alt').length) {
        if($('#preferred_countries_alt').length) {
            var input = document.querySelector("#phone_alt");
            var preferred_countries = document.querySelector('#preferred_countries_alt').value.split(",");
            if(input !== null) {
                var telephone_input = intlTelInput(input, {
                    initialCountry: (preferred_countries.length && preferred_countries[0] != "") ? preferred_countries[0] : 'GB',
                    preferredCountries: ["gb","ie","be", "dk", "no", "se"],
                    allowExtensions: true,
                    autoFormat: false,
                    autoHideDialCode: false,
                    autoPlaceholder: false,
                    defaultCountry: "ae",
                    ipinfoToken: "yolo",
                    nationalMode: false,
                    numberType: "MOBILE",
                    preventInvalidNumbers: true
                });
            }
        }
    
        var dc = document.querySelector("#dialcode_alt");
        var updateDialCode = function() {
            var countryData = telephone_input.getSelectedCountryData();
            if(dc) {
                dc.value = countryData.dialCode;
            }
        };
        if(input !== null) {
            input.addEventListener("countrychange", updateDialCode);
            updateDialCode();
        }
    
    }
}


//----------------------------------------------------
// endof :: Development Page Functions
//----------------------------------------------------


(function ($) {


    $(document).ready(function () {

        propertyCardImageSlider();
        propertyCardPriceRangeScroll();
        propertyCardFilterByPropertyTypes();
        customModal();
        developmentAreasSlider();
        ajaxForm();
        formIntTelInput();

    });

}(window.jQuery || window.$));